import { FC } from "react";

interface IErrorBoundaryQaThrowProps {
  error: Error | null;
}

export const ErrorBoundaryQaThrow: FC<IErrorBoundaryQaThrowProps> = ({
  error,
}) => {
  if (error) {
    throw error;
  }

  return null;
};
